import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { NavButtons } from './components/NavButtons';
import { useLoginOrSignupFooter } from './hooks/useLoginOrSignupFooter';

export const LoginOrSignupFooter: React.FC<EmptyProps> = () => {
	const {
		data: { hidden, loading, valid, canNavigateBack, canNavigateForward },
		actions: { gotoNextStep, gotoPreviousStep },
	} = useLoginOrSignupFooter();

	if (hidden) return null;

	return (
		<NavButtons
			data-qa="login-or-signup-footer-nav-buttons"
			forwardFunc={gotoNextStep}
			forwardText={canNavigateForward ? translationKey('corgi.sap.button.forward') : null}
			backwardFunc={gotoPreviousStep}
			desktopBackwardText={canNavigateBack ? translationKey('corgi.sap.button.back') : null}
			mobileBackwardText={canNavigateBack ? translationKey('corgi.sap.button.back') : null}
			validated={valid}
			nextStepLoading={loading}
		/>
	);
};
